document.addEventListener('DOMContentLoaded', function () {
    const promoBar = document.querySelector('.promo-bar');
    const promoContent = document.querySelector('.promo-bar-content');
    const promoTextDuplicate = document.querySelector('.promo-text-duplicate');

    if (!promoBar || !promoContent || !promoTextDuplicate) return;

    function checkIfMarqueeNeeded() {
        const promoBarWidth = promoBar.offsetWidth;
        const contentWidth = promoContent.scrollWidth;

        // Only add marquee class and show duplicate text if content is wider than container
        if (contentWidth > promoBarWidth) {
            promoContent.classList.add('marquee-active');
            promoTextDuplicate.style.display = 'inline-block';
        } else {
            promoContent.classList.remove('marquee-active');
            promoTextDuplicate.style.display = 'none';
        }
    }

    // Check on load
    checkIfMarqueeNeeded();

    // Check on window resize
    window.addEventListener('resize', checkIfMarqueeNeeded);

    // Check after a short delay to ensure fonts are loaded
    setTimeout(checkIfMarqueeNeeded, 1000);
});
